import { z } from 'zod';

import { Order } from 'Types/generic';

export const getSortOrder = (param: unknown): Order => {
	const sortOrder = z.nativeEnum(Order).safeParse(param);

	return sortOrder.success ? sortOrder.data : Order.Descending;
};

export const getSortBy = (param: unknown): string => {
	const sortBy = z.string().safeParse(param);

	return sortBy.success ? sortBy.data : 'soldDate';
};
